module.exports = __webpack_public_path__ + "static/media/425GriffinStNW_2018-06-05_39.2e4a8959.jpg";